export default "__VITE_ASSET__Q8FLra6j__"